import { HttpClient, HttpContext, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { JsonConvert } from "json2typescript";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { ShopStock } from "@hermes/api-model-shop";
import { Settings } from "@hermes/app-core";
import { SKIP_404_INTERCEPTOR } from "@hermes/utils/constants";
import { formatSkuForPLServices } from "@hermes/utils-generic/helpers";

@Injectable()
export class ProductLocatorService {
    constructor(private http: HttpClient, private settings: Settings) {}

    /**
     * call WS /stocks-by-shop to recover retail stock
     */
    public getStocksByShop(skus: string[]): Observable<ShopStock[]> {
        const params = new HttpParams().set(
            "skus",
            encodeURIComponent(
                skus.map((sku) => formatSkuForPLServices(sku)).join(";"),
            ),
        );
        const context = new HttpContext().set(SKIP_404_INTERCEPTOR, true);

        return this.http
            .get<ShopStock[]>(`${this.settings.apiUrl}/stocks-by-shop`, {
                context,
                params,
            })
            .pipe(
                map((shopStocks) =>
                    new JsonConvert().deserializeArray(shopStocks, ShopStock),
                ),
                catchError((error) => {
                    throw new Error(error.message);
                }),
            );
    }
}
